import { memo } from 'react'

const MailingStatsSkeleton = memo(function MailingStatsSkeleton() {
  return <div className="bg-skeleton-primary animate-pulse rounded-sm text-transparent">.</div>
})

export default MailingStatsSkeleton
